/**
 * Calculate amortized loan payment
 * @param {number} amount
 * @param {number} term
 * @param {float} apr
 *
 * @example
 * getMonthlyPayment(10000, 48, 5.99)
 */
export function getMonthlyPayment(amount, term, apr) {
  var r = apr / 100 / 12;
  return amount / ((Math.pow(1 + r, term) - 1) / (r * Math.pow(1 + r, term)));
}
/**
 * Given a treatment cost, calculate the default downpayment
 * @param {number} cost - Treatment cost
 * @param {number} maxDownpayment - Maximum allowed downpayment
 * @param {number} loanMinimum - Minimum allowed loan
 * @returns {number}
 */

export function getDownpayment(cost, maxDownpayment, loanMinimum) {
  var payment = cost / 2;
  return payment < loanMinimum ? maxDownpayment : payment;
}